import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { App } from "./App";
import { initGoogleAnalytics } from "./utils/analytics";
initGoogleAnalytics();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<ThemeProvider attribute="class" defaultTheme="light" enableSystem data-id="element-424" data-mp="26a26sxi1dpjg">
      <App data-id="element-425" data-mp="2abffdfcik6u2" />
    </ThemeProvider>);
}